export * from './lib/customer-registration.component';
